import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18n';
import { NOTIFICATION_TABS } from 'Reducers/notificationTray';
import MarkAllAsReadDialog from './MarkAllAsReadDialog';

const i18nOpts = { scope: 'notifications' };

const NotificationTabs = ({ activeTab, onTabChange, onMarkAllAsRead, hasUnreadNotifications }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleConfirm = () => {
    onMarkAllAsRead();
    setIsDialogOpen(false);
  };

  return (
    <>
      <div className="notification-tray__tabs" role="tablist">
        <button
          className={`notification-tray__tab ${activeTab === NOTIFICATION_TABS.UNREAD ? 'notification-tray__tab--active' : ''}`}
          onClick={() => onTabChange(NOTIFICATION_TABS.UNREAD)}
          role="tab"
          aria-selected={activeTab === NOTIFICATION_TABS.UNREAD}
        >
          {t('tabs.unread', i18nOpts)}
        </button>
        <button
          className={`notification-tray__tab ${activeTab === NOTIFICATION_TABS.ALL ? 'notification-tray__tab--active' : ''}`}
          onClick={() => onTabChange(NOTIFICATION_TABS.ALL)}
          role="tab"
          aria-selected={activeTab === NOTIFICATION_TABS.ALL}
        >
          {t('tabs.all', i18nOpts)}
        </button>
      </div>
      {hasUnreadNotifications && (
        <button
          className="notification-tray__mark-all-read"
          onClick={() => setIsDialogOpen(true)}
        >
          {t('mark_all_as_read', i18nOpts)}
        </button>
      )}
      <MarkAllAsReadDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={handleConfirm}
      />
    </>
  );
};

NotificationTabs.propTypes = {
  activeTab: PropTypes.oneOf([NOTIFICATION_TABS.UNREAD, NOTIFICATION_TABS.ALL]).isRequired,
  onTabChange: PropTypes.func.isRequired,
  onMarkAllAsRead: PropTypes.func.isRequired,
  hasUnreadNotifications: PropTypes.bool.isRequired,
};

export default NotificationTabs;
